import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import NavMenu from '../../../../components/NavMenu';
import { NavMenyItem } from '../../../../components/NavMenu/types';

import ContentContainer from '../../../../templates/Content/ContentContainer';
import Page1 from './Page1';
import CommunicationByActionAndOrder from './CommunicationByActionAndOrder';
import MotivesByActions from './MotivesByActions';

const Motives = () => {
  const { t } = useTranslation();
  const [tabSelected, setTabSelected] = useState({
    value: 'motives',
    name: 'motives',
  });

  const navMenuItems: NavMenyItem[] = [
    {
      title: t('motives'),
      action: () =>
        setTabSelected({
          value: 'motives',
          name: 'motives',
        }),
    },
    {
      title: t('communicationByActionAndOrder'),
      action: () =>
        setTabSelected({
          value: 'communicationByActionAndOrder',
          name: 'communicationByActionAndOrder',
        }),
    },
    {
      title: t('motivesByActions'),
      action: () =>
        setTabSelected({
          value: 'motivesByActions',
          name: 'motivesByActions',
        }),
    },
  ];

  const handleViewPag = (pagName: string) => {
    let pageSelected = <Page1 />;

    switch (pagName) {
      case 'motives':
        pageSelected = <Page1 />;
        break;
      case 'communicationByActionAndOrder':
        pageSelected = <CommunicationByActionAndOrder />;
        break;
      case 'motivesByActions':
        pageSelected = <MotivesByActions />;
        break;
      default:
        pageSelected = <Page1 />;
        break;
    }

    return pageSelected;
  };

  return (
    <ContentContainer title={t(tabSelected.value)}>
      <NavMenu items={navMenuItems} />

      {handleViewPag(tabSelected.value)}
    </ContentContainer>
  );
};

export default Motives;
